import React, { FC, memo, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';
import { Tooltip } from '@keaze/web/components/tooltip';
import { AvailabilityStatusCode } from '@keaze/web/common/enums';
import {
  StartRegistration as UIStartRegistration,
  Available,
  Info,
  Price,
  Header,
  Table,
  TableRow,
  TableCell,
  AvailableWrapper,
  AvailableGroup,
  RegisterButton,
  StyledActions,
  AvailableGroupSecondary,
} from './startRegistration.styles';
import { StartRegistrationProps, TableData } from './startRegistration.types';
import {
  useStartRegistration,
  convertValueToPrice,
} from './startRegistration.hook';

type GenerateAvailableArgs = {
  price: number | null;
  deposit: number | null;
  forSale: boolean;
  isSold: boolean;
};

type GenerateAvailable = (args: GenerateAvailableArgs) => JSX.Element;

type GeneratePriceArgs = {
  value: number | null;
  forSale: boolean;
  timeline: string;
};

type GeneratePrice = (args: GeneratePriceArgs) => JSX.Element;

type RenderTable = (rows: TableData[]) => JSX.Element;

type RenderTableRow = (row: TableData) => JSX.Element;

const generatePrice: GeneratePrice = ({ value, forSale, timeline }) => (
  <Price variant="body2">
    {convertValueToPrice(value) ?? 'TBD'}
    {forSale ? '' : ` (${timeline})`}
  </Price>
);

const S = {
  AvailabiltyWrapper: styled(Box) `
  h2 {
      
      text-align: center;
      
    ${({ theme: { colors, breakpoints } }) => `
      color: ${colors.browns.brown1} !important;
      ${breakpoints.up('md')} {
        font-size: 24px;
        text-align: left;
        margin: 0 0 15px 0;
      }
    `}
  }
  `,
 
  interestUL: styled.ul `{
    margin: 0;
    padding: 0;
  }`,
  interestLi: styled.li `{
 list-style-type: none;
 margin-bottom: 10px;
 display: flex; 
  }`,
  Title: styled.span `{
    ${({ theme: { colors} }) => `
    margin-right: 10px;
    font-size: 18px;
    color: ${colors.browns.brown1} !important;
    `}
  }`,

}

const generateAvailable: GenerateAvailable = ({
  price,
  deposit,
  forSale,
  isSold,
}) => {
  if (isSold) {
    return (
      <Available $isSold variant="caption">
        Sold out. Register interest for more information
      </Available>
    );
  }

  const priceAvailable = generatePrice({
    value: price,
    forSale,
    timeline: 'week',
  });
  const depositAvailable = generatePrice({
    value: deposit,
    forSale,
    timeline: 'month',
  });

  if (!forSale) {
    return (
      <AvailableWrapper>
        <AvailableGroup>
          <Available variant="body2">From</Available>
          {depositAvailable}
        </AvailableGroup>
        <AvailableGroupSecondary>
          <Available variant="body2">/</Available>
          {priceAvailable}
        </AvailableGroupSecondary>
      </AvailableWrapper>
    );
  }

  return (
    <S.AvailabiltyWrapper>
    
    
      <S.interestUL>
        <S.interestLi><S.Title>From</S.Title>{priceAvailable}</S.interestLi>
        <S.interestLi><S.Title>With min. deposit</S.Title>{depositAvailable}</S.interestLi>
      </S.interestUL>




{/* 
      <AvailableGroup>
        <Available variant="body2">
          From <span className='priceAvailable'>{priceAvailable}</span>
        </Available>
      </AvailableGroup>
      <AvailableGroupSecondary>
        <Available variant="body2">
          With min. deposit
          <span className='depositAvailable'>{depositAvailable}</span>  
        </Available>
      </AvailableGroupSecondary> */}
    </S.AvailabiltyWrapper>
  );
};

const renderTableRow: RenderTableRow = ({ name, value, hint }) => {
  const generatedName = hint ? (
    <Tooltip texts={[hint]} withDecoration>
      <>{name}</>
    </Tooltip>
  ) : (
    name
  );

  return (
    <TableRow key={name}>
      <TableCell>{generatedName}</TableCell>
      <TableCell>{value}</TableCell>
    </TableRow>
  );
};

const renderTable: RenderTable = (rows) => (
  <Table aria-label="region table">{rows.map(renderTableRow)}</Table>
);

export const SinglePropertyPrices: FC<StartRegistrationProps> = memo(
  ({
    listing,
    isLoading,
    isListingLoading,
    className,
    onRegisterButtonClick,
  }) => {
    const { price, deposit, rows } = useStartRegistration(listing);
    const isSold =
      listing.availabilityStatus.code === AvailabilityStatusCode.Sold;
    const withPropertyTable = useMemo(
      () => listing.singleProperty && rows.length !== 0,
      [listing, rows]
    );

    return (
      <UIStartRegistration
        $singleProperty={withPropertyTable}
        $isSold={isSold}
        className={className}
      >
      
        {withPropertyTable && renderTable(rows)}
      </UIStartRegistration>
    );
  }
);
